import React from "react";
import {
  DesktopHeader,
  Hamburger,
  HeaderLink,
  HeaderSecondWrapper,
  HeaderWrapper,
  ImageLogo,
  MobileHeaderContainer,
  MobileHeaderWrapper,
  MobileHeader,
  HeaderLinkCmp,
} from "./styles";
import LogoImage from "../../Assets/logooo.png";
import HamBurgerSvg from "../../Assets/Hamburger.svg";
import { useHistory } from "react-router";

const Navbar = () => {
  const [isMobileView, setIsMobileView] = React.useState(false);
  const [isTransparent , setIsTransparent] = React.useState(false);
  const handleScroll = ()=>{
    if(window.scrollY <= 400){
      setIsTransparent(true);
    }else{
      setIsTransparent(false);
    }
  }
  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    }
  } , []);
  const history = useHistory();
  return (
    <>
      <DesktopHeader>
        <HeaderWrapper isTransparent={isTransparent}>
          <ImageLogo src={LogoImage} />
          <HeaderSecondWrapper isTransparent={isTransparent}>
            <HeaderLinkCmp
              title={"Home"}
              link={"#"}
              onClick={() => {
                history.push("/");
              }}
            />

            <HeaderLinkCmp
              link={"#"}
              onClick={() => {
                history.push("/templates");
              }}
              title={"Templates"}
            />
            <HeaderLinkCmp
              link={"#"}
              title={"Pricing"}
              onClick={() => {
                history.push("/pricing");
              }}
            />
            <HeaderLinkCmp
              link={"#"}
              onClick={() => {
                history.push("/pricingtwo");
              }}
              title={"Pricing2"}
            />
          </HeaderSecondWrapper>
        </HeaderWrapper>
      </DesktopHeader>

      <MobileHeader>
        <MobileHeaderWrapper>
          <HeaderWrapper isTransparent={isTransparent}>
            <ImageLogo src={LogoImage} />
            <Hamburger
              src={HamBurgerSvg}
              onClick={() => setIsMobileView(!isMobileView)}
            />
          </HeaderWrapper>
          <MobileHeaderContainer
            height={isMobileView}
            isTransparent={isTransparent}
          >
            <HeaderLinkCmp
              title={"Home"}
              link={"#"}
              onClick={() => {
                history.push("/");
              }}
            />

            <HeaderLinkCmp
              link={"#"}
              onClick={() => {
                history.push("/templates");
              }}
              title={"Templates"}
            />
            <HeaderLinkCmp
              link={"#"}
              title={"Pricing"}
              onClick={() => {
                history.push("/pricing");
              }}
            />
            <HeaderLinkCmp
              link={"#"}
              onClick={() => {
                history.push("/pricingtwo");
              }}
              title={"Pricing2"}
            />
          </MobileHeaderContainer>
        </MobileHeaderWrapper>
      </MobileHeader>
    </>
  );
};

export default Navbar;
